import { combineEpics, Epic, ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as types from './types';
import { loopBackApi } from '../../models/LoopBack/Api/LoopBackApi';
import axios from 'axios';
import { notify } from '../../../services/notifier.service';
import { getLogisticsAPIUrl } from '../../../services/env.service';

const logisticsAPIUrl = getLogisticsAPIUrl();

const AbsenceEpic: Epic<any, any> = (action$, store) =>
  action$.pipe(
    ofType(types.FETCH_ABSENCE_REQUEST),
    mergeMap((action) =>
      loopBackApi()
        .get(`customers/absence/${action.payload.id}`)
        .then((res) => ({
          type: types.FETCH_ABSENCE_RECEIVE,
          payload: res.data
        }))
        .catch((err) => ({ type: types.FETCH_ABSENCE_ERROR }))
    )
  );

const MyCustomersEpic: Epic<any, any> = (action$, store) =>
  action$.pipe(
    ofType(types.GET_MY_CUSTOMERS_REQUEST),
    mergeMap((action) =>
      loopBackApi()
        .get(`customers/by-user`, action.payload)
        .then((res) => ({
          type: types.GET_MY_CUSTOMERS_RECEIVE,
          payload: res.data
        }))
        .catch((err) => ({ type: types.GET_MY_CUSTOMERS_ERROR }))
    )
  );

const MemoEpic: Epic<any, any> = (action$, store) =>
  action$.pipe(
    ofType(types.FETCH_MEMOS_REQUEST),
    mergeMap((action) =>
      loopBackApi()
        .get(`customers/memo/${action.payload.id}`)
        .then((res) => ({
          type: types.FETCH_MEMOS_RECEIVE,
          payload: res.data
        }))
        .catch((err) => ({ type: types.FETCH_MEMOS_ERROR }))
    )
  );

const PostAbsenceEpic: Epic<any, any> = (action$, store) =>
  action$.pipe(
    ofType(types.POST_ABSENCE_REQUEST),
    mergeMap((action) =>
      axios
        .post(`${logisticsAPIUrl}/customers/absence/${action.payload.id}`, action.payload.values)
        .then((res) => {
          notify({
            title: 'Gegevens opgeslagen',
            html: `De afwezigheid is succesvol opgeslagen`,
            type: 'success'
          });

          return {
            type: types.FETCH_ABSENCE_REQUEST,
            payload: { id: action.payload.id }
          };
        })
        .catch((err) => {
          notify({
            title: 'Helaas',
            html: `Er is iets mis gegaan bij het opslaan van de afwezigheid. Probeer het later nogmaals of neem contact op`,
            type: 'error'
          });
          return { type: types.POST_ABSENCE_ERROR };
        })
    )
  );

export const customerEpics = combineEpics(AbsenceEpic, MemoEpic, PostAbsenceEpic, MyCustomersEpic);
